import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IfCblcDirective } from './if-cblc.directive';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ IfCblcDirective ],
    exports: [ IfCblcDirective ],
})
export class IfCblcDirectiveModule {}
